module.exports = __webpack_public_path__ + "img/secure.8292b775.png";